<template>
  <section class="sample-info">
    <div class="metals">
      <h3 class="section-title">Metals</h3>
      <div class="metals-wrapper">
        <dl>
          <dt>Copper (Cu)</dt>
          <dd :class="`severity-id-${oilSample.copperSeverity.toLowerCase()}`">
            {{ oilSample.copper }}
          </dd>
          <dt>Chromium (Cr)</dt>
          <dd :class="`severity-id-${oilSample.chromiumSeverity.toLowerCase()}`">
            {{ oilSample.chromium }}
          </dd>
          <dt>Silicon (Si)</dt>
          <dd :class="`severity-id-${oilSample.siliconSeverity.toLowerCase()}`">
            {{ oilSample.silicon }}
          </dd>
          <dt>Calcium (Ca)</dt>
          <dd :class="`severity-id-${oilSample.calciumSeverity.toLowerCase()}`">
            {{ oilSample.calcium }}
          </dd>
          <dt>Zinc (Zn)</dt>
          <dd :class="`severity-id-${oilSample.zincSeverity.toLowerCase()}`">
            {{ oilSample.zinc }}
          </dd>
          <dt>Molybdenum (Mo)</dt>
          <dd :class="`severity-id-${oilSample.molybdenumSeverity.toLowerCase()}`">
            {{ oilSample.molybdenum }}
          </dd>
          <dt>Silver (Ag)</dt>
          <dd :class="`severity-id-${oilSample.silverSeverity.toLowerCase()}`">
            {{ oilSample.silver }}
          </dd>
          <dt>Tin (Sn)</dt>
          <dd :class="`severity-id-${oilSample.tinSeverity.toLowerCase()}`">{{ oilSample.tin }}</dd>
          <dt>Sodium (Na)</dt>
          <dd :class="`severity-id-${oilSample.sodiumSeverity.toLowerCase()}`">
            {{ oilSample.sodium }}
          </dd>
        </dl>
        <dl>
          <dt>Iron (Fe)</dt>
          <dd :class="`severity-id-${oilSample.ironSeverity.toLowerCase()}`">
            {{ oilSample.iron }}
          </dd>
          <dt>Aluminum (Al)</dt>
          <dd :class="`severity-id-${oilSample.aluminumSeverity.toLowerCase()}`">
            {{ oilSample.aluminum }}
          </dd>
          <dt>Lead (Pb)</dt>
          <dd :class="`severity-id-${oilSample.leadSeverity.toLowerCase()}`">
            {{ oilSample.lead }}
          </dd>
          <dt>Magnesium (Mg)</dt>
          <dd :class="`severity-id-${oilSample.magnesiumSeverity.toLowerCase()}`">
            {{ oilSample.magnesium }}
          </dd>
          <dt>Phosphorus (P)</dt>
          <dd :class="`severity-id-${oilSample.phosphorousSeverity.toLowerCase()}`">
            {{ oilSample.phosphorous }}
          </dd>
          <dt>Boron (B)</dt>
          <dd :class="`severity-id-${oilSample.boronSeverity.toLowerCase()}`">
            {{ oilSample.boron }}
          </dd>
          <dt>Nickel (Ni)</dt>
          <dd :class="`severity-id-${oilSample.nickelSeverity.toLowerCase()}`">
            {{ oilSample.nickel }}
          </dd>
          <dt>Potassium (K)</dt>
          <dd :class="`severity-id-${oilSample.potassiumSeverity.toLowerCase()}`">
            {{ oilSample.potassium }}
          </dd>
        </dl>
      </div>
    </div>
    <div class="ftir">
      <h3 class="section-title">FTIR</h3>
      <dl>
        <dt>Soot Index</dt>
        <dd :class="`severity-id-${oilSample.sootIndexSeverity.toLowerCase()}`">
          {{ oilSample.sootIndex }}
        </dd>
        <dt>Fuel Dilution</dt>
        <dd :class="`severity-id-${oilSample.fuelDilutionSeverity.toLowerCase()}`">
          {{ oilSample.fuelDilution }}
        </dd>
        <dt>Antifreeze</dt>
        <dd :class="`severity-id-${oilSample.antifreezeSeverity.toLowerCase()}`">
          {{ oilSample.antifreeze }}
        </dd>
        <dt>Water (%)</dt>
        <dd :class="`severity-id-${oilSample.waterSeverity.toLowerCase()}`">
          {{ oilSample.waterPercent }}
        </dd>
        <dt>Water (ppm)</dt>
        <dd :class="`severity-id-${oilSample.waterSeverity.toLowerCase()}`">
          {{ oilSample.waterPpm }}
        </dd>
        <dt>Oxidation (D7414)</dt>
        <dd :class="`severity-id-${oilSample.newOxidationSeverity.toLowerCase()}`">
          {{ oilSample.newOxidation }}
        </dd>
        <dt>Nitration (D7624)</dt>
        <dd :class="`severity-id-${oilSample.newNitrationSeverity.toLowerCase()}`">
          {{ oilSample.newNitration }}
        </dd>
        <dt>Sulfation (D7415)</dt>
        <dd :class="`severity-id-${oilSample.newSulfationSeverity.toLowerCase()}`">
          {{ oilSample.newSulfation }}
        </dd>
        <dt>BN (D4739)</dt>
        <dd :class="`severity-id-${oilSample.tbnSeverity.toLowerCase()}`">{{ oilSample.tbn }}</dd>
        <dt>BN (D2896)</dt>
        <dd :class="`severity-id-${oilSample.bnSeverity.toLowerCase()}`">{{ oilSample.bn }}</dd>
        <dt>AN (D664)</dt>
        <dd :class="`severity-id-${oilSample.tanSeverity.toLowerCase()}`">{{ oilSample.tan }}</dd>
      </dl>
    </div>
    <div class="viscosity">
      <h3 class="section-title">Viscosity</h3>
      <dl>
        <dt>Viscosity 40c</dt>
        <dd :class="`severity-id-${oilSample.viscosity40cSeverity.toLowerCase()}`">
          {{ oilSample.viscosity40c }}
        </dd>
        <dt>Viscosity 100c</dt>
        <dd :class="`severity-id-${oilSample.viscosity100cSeverity.toLowerCase()}`">
          {{ oilSample.viscosity100c }}
        </dd>
      </dl>
    </div>
    <div class="advanced-properties">
      <h3 class="section-title">Advanced Properties</h3>
      <dl>
        <dt>Sulfur (ppm)</dt>
        <dd :class="`severity-id-${oilSample.sulphurSeverity.toLowerCase()}`">
          {{ oilSample.sulphur }}
        </dd>
        <dt>Chlorine (ppm)</dt>
        <dd :class="`severity-id-${oilSample.chlorineSeverity.toLowerCase()}`">
          {{ oilSample.chlorine }}
        </dd>
        <dt>MPC</dt>
        <dd :class="`severity-id-${oilSample.mPCSeverity.toLowerCase()}`">
          {{ oilSample.mpc }}
        </dd>
      </dl>
    </div>
    <div class="particle-counts">
      <h3 class="section-title">Particle Counts</h3>
      <dl>
        <dt>ISO Class Code</dt>
        <dd :class="`severity-id-${oilSample.isoClassCodeSeverity.toLowerCase()}`">
          {{ oilSample.isoClassCode }}
        </dd>
        <dt>4 Micron</dt>
        <dd :class="`severity-id-${oilSample.particleCount4Severity.toLowerCase()}`">
          {{ oilSample.particleCount4 }}
        </dd>
        <dt>6 Micron</dt>
        <dd :class="`severity-id-${oilSample.particleCount6Severity.toLowerCase()}`">
          {{ oilSample.particleCount6 }}
        </dd>
        <dt>10 Micron</dt>
        <dd :class="`severity-id-${oilSample.particleCount10Severity.toLowerCase()}`">
          {{ oilSample.particleCount10 }}
        </dd>
        <dt>14 Micron</dt>
        <dd :class="`severity-id-${oilSample.particleCount14Severity.toLowerCase()}`">
          {{ oilSample.particleCount14 }}
        </dd>
        <dt>25 Micron</dt>
        <dd :class="`severity-id-${oilSample.particleCount25To50Severity.toLowerCase()}`">
          {{ oilSample.particleCount25 }}
        </dd>
        <dt>50 Micron</dt>
        <dd :class="`severity-id-${oilSample.particleCount50Severity.toLowerCase()}`">
          {{ oilSample.particleCount50 }}
        </dd>
        <dt>100 Micron</dt>
        <dd :class="`severity-id-${oilSample.particleCount100Severity.toLowerCase()}`">
          {{ oilSample.particleCount100 }}
        </dd>
      </dl>
    </div>
  </section>
</template>

<script>
import RoundingMixin from '../../shared/RoundingMixin';
export default {
  name: 'OilSampleDetailSampleInfo',
  props: {
    oilSample: {
      type: Object,
      required: true
    }
  },
  mixins: [RoundingMixin]
};
</script>

<style lang="scss" scoped>
.sample-info {
  border-top: dotted 2px $black;
  display: flex;
  flex-basis: 100%;
  flex-flow: row nowrap;
  margin-top: 10px;
  padding-top: 10px;

  .section-title {
    font-style: italic;
  }

  .severity-id {
    &-reportable {
      background: nth($severity-color-reportable, 2);
    }

    &-abnormal {
      background: nth($severity-color-abnormal, 2);
    }

    &-critical {
      background: nth($severity-color-critical, 2);
    }
  }

  .metals {
    flex-basis: 40%;

    &-wrapper {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));

      dl {
        margin: 0;
      }
    }
  }

  .ftir,
  .viscosity,
  .particle-counts,
  .advanced-properties {
    border-left: dotted 2px $black;
    flex-basis: 20%;
  }

  .metals,
  .ftir,
  .viscosity,
  .particle-counts,
  .advanced-properties {
    padding: 10px;

    h3 {
      margin-left: 23px;
      color: $accent;
    }

    dl {
      width: 100%;
    }

    dl dt,
    dl dd {
      border-bottom: solid 1px #ddd;
      padding-top: 2px;
      display: block;
    }

    dt {
      float: left;
      font-weight: bold;
      padding: 2px 6px 0 6px;

      &::after {
        content: ':';
        margin-right: 5px;
      }
    }

    dd {
      display: table;
      min-height: 20px;
      text-align: right;
      padding: 2px 6px 0 6px;
      margin-right: 5px;
    }
  }
}
</style>
